export const getInfluencer = (
  campaign_influencers,
  video_campaign_influencer_ids
) =>
  campaign_influencers.find(
    (i) => video_campaign_influencer_ids.indexOf(i.id) !== -1
  ) || {};

export const getVideo = (videos, id) => videos.find((v) => v.id === id) || {};
